import { z } from "zod";

export const ScopeId = z
  .object({
    nodeId: z.number(),
    key: z.string().optional(),
  })
  .readonly();

export type ScopeId = z.infer<typeof ScopeId>;

export const RuntimeNodeId = z
  .object({
    nodeId: z.number(),
    scopeId: ScopeId,
  })
  .readonly();

export type RuntimeNodeId = z.infer<typeof RuntimeNodeId>;
